import Vue from 'vue'
import loadFormsComponents from './formsComponents.js'
import dataTools from '../../tools/data'
import componentTools from '../../tools/components'
loadFormsComponents()

export default () => {
  Vue.component('exo-constellation-payload-parameter', {
    props: {
      root: Object,
      tooltip: String,
      name: String,
      type: String
    },
    computed: {
      getParentObject() {
        return componentTools.getParentObject(this)
      },
      getUnit() {
        return ` (${dataTools.getDefaultGuiUnit(
          this.root.getVisibilityParameterUnit(this.type)
        )})`
      }
    },

    template: `
              <v-row no-gutters>
                <v-text-field horizontal
                          :label="root.getFormLabel(name) + getUnit"
                          v-model="root.inputs[name]"
                          :rules="[root.getFieldState(getParentObject, name).message]"
                          >
                </v-text-field>
              </v-row>
    `
  })
}
